import { motion } from "framer-motion";
import { Check, Bike, ShieldCheck, UserCheck, Route, Home, UtensilsCrossed, Wrench, Map, LifeBuoy, BatteryCharging, CloudSun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Chapter, Reveal, EASE } from "./shared";

const ICONS = [Bike, ShieldCheck, UserCheck, Route, Home, UtensilsCrossed, Wrench, Map, LifeBuoy, BatteryCharging];

export default function HolidayIncluded() {
  const { t } = useTranslation();
  const items = t("holidays.included.items", { returnObjects: true });
  return (
    <section className="bg-bone py-24 lg:py-40" data-testid="holidays-included">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <Chapter number={t("holidays.included.chapter")} label={t("holidays.included.eyebrow")} />
            <Reveal delay={0.1}>
              <h2 className="font-display text-5xl sm:text-6xl text-forest leading-[1.02] mt-8">
                {t("holidays.included.title_a")}<br /><span className="italic">{t("holidays.included.title_b")}</span>
              </h2>
            </Reveal>
            <Reveal delay={0.2} className="mt-8 flex items-start gap-3 text-sm text-muted-foreground leading-relaxed max-w-sm">
              <CloudSun className="w-5 h-5 text-terracotta shrink-0 mt-0.5 stroke-[1.5]" />
              <p data-testid="included-note">{t("holidays.included.note")}</p>
            </Reveal>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-bone-deep border border-bone-deep">
            {items.map((label, i) => {
              const Icon = ICONS[i] || Check;
              return (
                <motion.div
                  key={i}
                  data-testid={`included-item-${i}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "0px 0px -40px 0px" }}
                  transition={{ duration: 0.7, ease: EASE, delay: (i % 2) * 0.08 + Math.floor(i / 2) * 0.06 }}
                  className="group bg-bone hover:bg-forest p-6 lg:p-7 flex items-start gap-4 transition-colors duration-500"
                >
                  <div className="w-10 h-10 shrink-0 border border-bone-deep group-hover:border-bone/20 flex items-center justify-center text-forest group-hover:text-bone transition-colors duration-500">
                    <Icon className="w-5 h-5 stroke-[1.5]" />
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-wider-3 text-moss group-hover:text-bone/60 transition-colors duration-500">{String(i + 1).padStart(2, "0")}</div>
                    <div className="text-sm md:text-base text-forest group-hover:text-bone leading-snug mt-1.5 transition-colors duration-500">{label}</div>
                  </div>
                  <Check className="w-4 h-4 text-terracotta ml-auto shrink-0 mt-1" />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
